import React from "react";

const NewsLetterAreaTwo = () => {
  return (
    <section className="newsletter-area-two">
      <div className="container">
        <div className="newsletter-wrap">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-9">
              <div className="section-title title-style-two white-title text-center mb-30">
                <h2 className="title">با عضویت در خبرنامه ما، از آخرین به‌روزرسانی‌ها و پیشنهادات ویژه باخبر شوید و در مسیر دستیابی به رویاهای مالی خود قدم بردارید.</h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xl-8">
              <div className="newsletter-form">
                <form action="#">
                  <button type="submit" className="btn">
                    ارسال <span></span>
                  </button>
                  <input type="email" placeholder="لطفا ایمیل خود را وارد کنید"/>

                </form>
              </div>
            </div>
          </div>

          <div className="newsletter-shape-wrap-two">
            <img src="/img/images/h3_newsletter_shape01.png" alt="" />
            <img src="/img/images/h3_newsletter_shape02.png" alt="" />
            <img src="/img/images/h3_newsletter_shape03.png" alt="" />
            <img src="/img/images/h3_newsletter_shape04.png" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsLetterAreaTwo;
